module.exports = __webpack_public_path__ + "static/media/template_back.6d72300f.png";